import script from "./cashbackWeekDayCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./cashbackWeekDayCard.vue?vue&type=script&lang=ts&setup=true"

import "./cashbackWeekDayCard.vue?vue&type=style&index=0&id=1530a25c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1530a25c"]])

export default __exports__